import { withTheme } from '@mui/styles';
import styled from 'styled-components';

const ContentSectionStyle = withTheme(styled.div`
  padding: 60px 0px;
  background: #f7f7f7;

  .top-container {
    margin-bottom: 50px;
  }

  .stat-container {
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;

    .stat-box {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      margin-right: 16px;

      .stat-number {
        width: 68px;
        height: 68px;
        border: solid 10px rgba(23, 72, 67, 0.4);
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;

        font-size: 25px;
        font-weight: bold;
        color: ${(props: any) => props.theme.palette.primary.dark};
      }

      .stat-title {
        color: #707070;
      }
    }
  }

  .MuiTabs-root {
    .MuiTabs-scroller {
      border-bottom: solid 3px ${(props: any) => props.theme.palette.primary.dark};
    }

    .MuiTabScrollButton-root {
      display: none;
    }

    .MuiTabs-indicator {
      display: none;
    }

    .MuiTab-root {
      font-size: 24px;
      font-weight: bold;
      color: #707070;
      text-transform: capitalize;
      padding: 0px 35.5px;

      &.Mui-selected {
        border-radius: 10px 10px 0px 0px;
        color: white;
        background-color: ${(props: any) => props.theme.palette.primary.dark};
      }
    }
  }

  .tab-content {
    padding-top: 24px;

    .category-list {
      display: flex;
      flex-flow: row wrap;

      .category-box {
        padding: 2px 16px;
        border-radius: 13px;
        background-color: #e6e6e6;
        margin-right: 8px;
        margin-bottom: 16px;

        font-size: 18px;
        font-weight: bold;
        color: #9b9b9b;
      }
    }
  }

  .course-card-container {
    position: relative;
    height: 200px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .remark {
    font-size: 16px;
    text-align: right;
    color: #a0a0a0;
  }

  ${(props: any) => props.theme.breakpoints.down('lg')} {
    .top-container {
      margin-bottom: 30px;
    }

    .stat-container {
      align-items: center;
      justify-content: center;
      margin-top: 16px;
    }

    .MuiTabs-root {
      margin-left: -16px;
      margin-right: -16px;

      .MuiTabs-scrollButtons {
        display: flex;
      }
    }

    .tab-content {
      .category-list {
        justify-content: center;
      }
    }

    .course-card-container {
      height: ${(props: any) => props.width / 1.77 / 2}px;
    }

    .remark {
      margin-top: 20px;
      text-align: center;
    }
  }
  ${(props: any) => props.theme.breakpoints.down('sm')} {
    .stat-container {
      .stat-box {
        margin-right: 8px;
      }
    }

    .MuiTabs-root {
      .MuiTabScrollButton-root {
        width: 30px;
      }
      .MuiTab-root {
        font-size: 18px;
        padding-left: 20px;
        padding-right: 20px;
      }
    }

    .tab-content {
      .category-list {
        justify-content: start;
      }
    }
  }
`);

export default ContentSectionStyle;
